import { Box, Stack } from '@mui/material';
import React from 'react';

export interface HomeProductCardRowProps {
  children: React.ReactNode;
  spacing?: number;
  px?: number;
}

const HomeProductCardRow: React.FC<HomeProductCardRowProps> = ({
  children,
  spacing = 2,
  px = 2,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        overflowX: 'auto',
        overflowY: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        mx: -px,
        px,
      }}
    >
      <Stack
        direction="row"
        spacing={spacing}
        sx={{
          width: 'max-content',
          minWidth: '100%',
          py: 0.5,
        }}
      >
        {children}
      </Stack>
    </Box>
  );
};

export default HomeProductCardRow;
